/** @jsxImportSource @emotion/react */
import { useTheme } from "basis";
import { FC } from "react";

type Props = {
  vertical?: boolean;
};

const Separator: FC<Props> = ({ vertical = false }) => {
  const theme = useTheme();
  const css = vertical
    ? {
        height: "100%",
        borderLeft: `1px dashed ${theme.getColor("grey.t10")}`,
      }
    : {
        borderTop: `1px dashed ${theme.getColor("grey.t10")}`,
      };

  return <div css={css} />;
};

export { Separator };
